import { ComponentsOverrides } from '@mui/material/styles/overrides';
import { paperClasses as muiPaperClasses } from '@mui/material/Paper';
import { autocompleteClasses } from '.';
import { INPUT_BORDER_RADIUS } from '../theme/constants';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import palette from '../theme/palette';
import colors from '../theme/colors';
import { Theme } from '@mui/material/styles';
import typography from '../theme/typography';

const styleOverrides: ComponentsOverrides['MuiAutocomplete'] = {
  input: {
    // artificially increase specificity - padding is normally set with .Mui_Input-root.MuiAutocomplete-input
    [`&.${autocompleteClasses.input}`]: {
      padding: 0,
      paddingTop: '2px',
    },
  },
  popper: {
    [`& > .${muiPaperClasses.root}`]: {
      borderRadius: INPUT_BORDER_RADIUS,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: palette.primary.main,
      borderTopColor: colors.transparentGray[100],
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      boxSizing: 'border-box',
    },
  },
  clearIndicator: ({ theme }) => ({
    marginRight: (theme as Theme).spacing(0.5),
  }),
  inputRoot: ({ ownerState }) => ({
    [`&.${outlinedInputClasses.root}:hover > .${outlinedInputClasses.notchedOutline}`]: {
      borderWidth: '2px',
    },
    ...(ownerState.popupOpen === true && {
      [`&.${outlinedInputClasses.root} > .${outlinedInputClasses.notchedOutline}`]: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderWidth: '1px',
        borderBottomStyle: 'none',
      },
      /**
       * Required to fill background completely. Otherwise, input background shows rounded corners on bottom left/right.
       */
      [`&.${outlinedInputClasses.root}`]: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
      [`&.${outlinedInputClasses.root}:hover > .${outlinedInputClasses.notchedOutline}`]: {
        borderWidth: '1px',
      },
    }),
    ...(ownerState.color === 'internal' && {
      color: palette.internal.main,
      [`&.${outlinedInputClasses.root}.${autocompleteClasses.focused} > .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: palette.primary.main,
      },
    }),
  }),
  // Keep same selector specificity as original MUI Autocomplete
  listbox: ({ theme, ownerState }) => ({
    [`& .${autocompleteClasses.option}`]: {
      color: palette.text.secondary,
      paddingLeft: (theme as Theme).spacing(1),
      [`&.${autocompleteClasses.focused}:hover`]: {
        backgroundColor: colors.brandPrimary[100],
        color: palette.text.secondary,
      },
      [`&[aria-selected="true"]`]: {
        backgroundColor: colors.transparentGray[100],
        color: palette.text.primary,
        fontWeight: typography.fontWeightRegular,
        [`&.${autocompleteClasses.focused}`]: {
          backgroundColor: colors.transparentGray[100],
          color: palette.text.primary,
          '&:hover': {
            backgroundColor: colors.brandPrimary[100],
          },
        },
      },
    },
    ...(ownerState.color === 'internal' && {
      [`& .${autocompleteClasses.option}`]: {
        [`&[aria-selected="true"]`]: {
          backgroundColor: colors.internal[200],
          [`&.${autocompleteClasses.focused}`]: {
            backgroundColor: colors.internal[200],
            '&:hover': {
              backgroundColor: colors.brandPrimary[100],
            },
          },
        },
        [`&.${autocompleteClasses.focused}`]: {
          backgroundColor: colors.internal[100],
        },
      },
      [`& .${autocompleteClasses.option}:hover`]: {
        backgroundColor: colors.brandPrimary[100],
      },
    }),
  }),
  tag: {
    border: `1px solid ${colors.transparentGray[300]}`,
  },
};

export default styleOverrides;
